import axios from "axios";

export default class BaseApi {
  constructor() {
    this.axios = axios.create({
      baseURL: "http://backend.zz-group.biz/",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}
